import { Entity } from 'engine/Entity';
import { ColliderFacet, ColliderType } from 'engine/facets/ColliderFacet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { RockWallSprite } from './RockWallSprite';

export class RockWallEntity extends Entity {
  createFacets() {
    return [
      create(StaticSpriteFacet, { frame: RockWallSprite }),
      create(ColliderFacet, { type: ColliderType.Circle, radius: 633, offset: [0, 584] }),
      create(ColliderFacet, {
        type: ColliderType.Polygon,
        offset: [0, 0],
        points: [[90, -404], [529, -404], [0, 1146]],
      }),
    ];
  }
}
